import { useState } from 'react';
import { IconMail } from '@tabler/icons-react';
import { Anchor } from '@mantine/core';
import { Modal, Stack, Text } from '@datavant/dart';
import { RmV2SupportView } from './RmV2SupportView';

export const RmV2PeerMigratedModal = (): JSX.Element => {
    const [showSupport, setShowSupport] = useState(false);

    return (
        <Modal
            opened
            onClose={() => undefined}
            withCloseButton={false}
            closeOnClickOutside={false}
            closeOnEscape={false}
            size={520}
            centered
            styles={{ body: { padding: 'var(--mantine-spacing-xl)' } }}
        >
            {showSupport ? (
                <RmV2SupportView onBack={() => setShowSupport(false)} />
            ) : (
                <Stack gap="lg" align="center">
                    <IconMail size={64} strokeWidth={1.5} color="var(--mantine-color-blue-4)" />
                    <Text fw={700} fz="xl" ta="center">
                        Request Manager has been upgraded for your organization.
                    </Text>
                    <Text size="sm" ta="center">
                        To access the new portal, you&apos;ll need to set up your new account.{' '}
                        <Text component="span" size="sm" fw={700}>
                            Check your email for an invitation with your next steps
                        </Text>{' '}
                        &mdash; it takes about 5 minutes to complete.
                    </Text>
                    <Text size="sm" c="dimmed" ta="center">
                        Haven&apos;t received it? Check your spam folder, or{' '}
                        <Anchor component="button" size="sm" onClick={() => setShowSupport(true)}>
                            Contact Support
                        </Anchor>
                    </Text>
                </Stack>
            )}
        </Modal>
    );
};
